import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Speaker } from 'lucide-react';
import { formatLegalVersion } from '../../config/legal';

interface LegalPageLayoutProps {
  title: string;
  otherPage: { to: string; label: string };
  children: ReactNode;
}

export function LegalPageLayout({ title, otherPage, children }: LegalPageLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 py-10 px-4">
      <article className="max-w-3xl mx-auto bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 sm:p-10 text-gray-700 dark:text-gray-300 leading-relaxed">
        <div className="flex items-center gap-3 mb-6">
          <Speaker className="w-8 h-8 text-primary" />
          <span className="text-xl font-bold text-gray-900 dark:text-white">VoteBeats</span>
        </div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">{title}</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">Last updated {formatLegalVersion()}</p>

        <div className="space-y-8 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-gray-900 dark:[&_h2]:text-white [&_h2]:mb-3 [&_h3]:font-semibold [&_h3]:text-gray-900 dark:[&_h3]:text-white [&_h3]:mt-4 [&_h3]:mb-2 [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_ul]:mb-3 [&_a]:text-primary [&_a]:underline">
          {children}
        </div>

        <nav className="mt-10 pt-6 border-t border-gray-200 dark:border-gray-800 flex flex-wrap gap-6 text-sm">
          <Link to="/" className="inline-flex items-center gap-2 text-primary hover:underline">
            <ArrowLeft className="w-4 h-4" />
            Back to VoteBeats
          </Link>
          <Link to={otherPage.to} className="text-primary hover:underline">
            {otherPage.label}
          </Link>
        </nav>
      </article>
    </div>
  );
}
